





import { defineComponent } from '@vue/composition-api';
import linkList from '@/renderer/components/linkList/index.vue';
export default defineComponent({
  components: {
    linkList,
  },
});
